import React from 'react';
import SignUpModal from '../../signUp/sign.up.modal';
import { POSSIBLE_FORMS } from '../../signUp/sign.up.memo.form';

export function SignUpModalButton() {
  return (
    <SignUpModal
      id="Hero"
      signupType={POSSIBLE_FORMS.SIGN_UP}
      className="a-navigation__starterButton -desktop"
      label="web.navigation.start.now"
    />
  );
}

export default SignUpModalButton;
